import React from 'react';
import { COPY } from '@app/lib/content';
import { useLang } from '@app/lib/useLang';
import { CONTACTS, QUEST_IDS, pagePath } from '@app/lib/site';
import { track } from '@app/lib/track';
import { PageHero } from '@widgets';
import styles from '../pageStyles.module.css';

const TeamBuildingPage: React.FC = () => {
  const lang = useLang();
  const c = COPY[lang];
  const t = c.team;

  const whatsapp = `${CONTACTS.whatsappLink}?text=${encodeURIComponent(t.whatsappText)}`;
  const whatsappInvoice = `${CONTACTS.whatsappLink}?text=${encodeURIComponent(t.invoiceWhatsappText)}`;
  const mail = `mailto:${CONTACTS.email}?subject=${encodeURIComponent(t.emailSubject)}`;
  const onContact = (channel: string) => () => track('team_building_contact_click', { channel, language: lang });

  return (
    <main>
      <PageHero image="/img/hero-1920.jpg" title={t.h1} lead={t.lead} />

      <div className={styles.wrapper}>
        <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
          <a href={pagePath('home', lang)}>{c.ui.home}</a> <span aria-hidden>›</span> <span>{c.ui.nav}</span>
        </nav>

        {t.sections.map((s) => (
          <section key={s.title} className={styles.section}>
            <h2 className={styles.h2}>{s.title}</h2>
            {s.text && <p className={styles.text}>{s.text}</p>}
            {s.items && (
              <ul className={styles.list}>
                {s.items.map((i) => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <section className={styles.section}>
          <h2 className={styles.h2}>{t.routesTitle}</h2>
          <ul className={styles.routeLinks}>
            {QUEST_IDS.map((id) => (
              <li key={id}>
                <a href={pagePath(id, lang)}>{c.quests[id].h1}</a>
              </li>
            ))}
          </ul>
        </section>

        <section className={`${styles.section} ${styles.order}`} id="order">
          <h2 className={styles.h2}>{t.orderTitle}</h2>
          <p className={styles.text}>{t.orderText}</p>
          <ul className={styles.list}>
            {t.orderItems.map((i) => (
              <li key={i}>{i}</li>
            ))}
          </ul>
          <p className={styles.text}>
            {t.invoiceBefore}
            <a href={whatsappInvoice} target="_blank" rel="noopener noreferrer" onClick={onContact('whatsapp_invoice')}>
              {t.invoiceLink}
            </a>
            {t.invoiceAfter}
          </p>
          <div className={styles.ctaRow}>
            <a className={styles.cta} href={whatsapp} target="_blank" rel="noopener noreferrer" onClick={onContact('whatsapp')}>
              {t.whatsappCta}
            </a>
            <a className={styles.ctaSecondary} href={mail} onClick={onContact('email')}>
              {t.emailCta}
            </a>
          </div>
          <p className={styles.note}>
            WhatsApp: {CONTACTS.whatsappDisplay} · {CONTACTS.email}
          </p>
        </section>
      </div>
    </main>
  );
};

export default TeamBuildingPage;
